import { MenuItem } from '@headlessui/react';
import { Link } from 'gatsby';
import React, { FunctionComponent } from 'react';
import config from '../../config';

interface IProps {
    name: string;
    link: string;
    icon: FunctionComponent<{ className: string }>;
}

const itemClassName =
    'inline-flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:text-gray-800 data-[focus]:bg-gray-100 data-[focus]:outline-none hover:no-underline hover:bg-gray-100';

export default function NavbarMenuItem(props: IProps) {
    const { name, link, icon: Icon } = props;
    const isTeamSubdomain = typeof location !== 'undefined' && config.isTeamSubdomainPage(location);

    if (isTeamSubdomain) {
        return (
            <MenuItem>
                <a href={`https://biolib.com${link}`} className={itemClassName}>
                    <Icon className='size-4 mr-2 text-gray-500' /> {name}
                </a>
            </MenuItem>
        );
    }

    return (
        <MenuItem>
            <Link to={link} className={itemClassName}>
                <Icon className='size-4 mr-2 text-gray-500' /> {name}
            </Link>
        </MenuItem>
    );
}
